// extracted by mini-css-extract-plugin
module.exports = {"modalVideo":"YoutubeVideo_modalVideo__3boJz","iframeVideo":"YoutubeVideo_iframeVideo__1iFY8"};